import { RouteObject } from 'react-router-dom';
import { NubUserManagement } from './views/NubUserManagement';
import { UserProfileView } from './views/UserProfileView';
import { UserMigrationView } from './views/UserMigrationView';
import { UserSecurityView } from './views/UserSecurityView';
import {ErrorBoundary} from "@/shared/components/ErrorBoundary.tsx";
import { accessLevelRoutes } from './modules/access-level/routes';
import { groupRoutes } from './modules/user-group/routes';

export const nubUserRoutes: RouteObject[] = [
    {
        path: '/user/profile',
        element: <UserProfileView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/nub/users',
        element: <NubUserManagement />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/nub/users/migration',
        element: <UserMigrationView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/nub/user-security',
        element: <UserSecurityView />,
        errorElement: <ErrorBoundary />,
    },
    ...accessLevelRoutes,
    ...groupRoutes,
];